
import Tenant from "./tenant";
import { WhatsAppConnection } from "./whatsapp-connection";
import WhatsAppPod, { IncomingWhatsAppPod } from "./whatsapp-pod";
import { IncomingNiboWhatsAppData } from "./incoming-nibo-whatsapp-data";


export default class NiboWhatsAppConnection {

    public connectionId: string;
    public connection?: WhatsAppConnection;
    public pod?: WhatsAppPod;
    public tenant?: Tenant;

    public labels: { [key: string]:string } = {};
    public stringifiedLabels?: string;

    public wahaImage?: string;
    public niboWAHAImage?: string;
    public niboWAHAVersion?: string;
    public niboWAHAChartVersion?: string;
    public wahaEnableTagEvents?: boolean;
    public wahaLogLevel?: string;
    public vpaConfigWAHAMinAllowedMemory?: string;
    public vpaConfigWAHAMaxAllowedMemory?: string;
    public volumeSize?: string;

    constructor(data: IncomingNiboWhatsAppData) {
        if (!(data.connection?.id || data.pod?.connectionId))
            throw new Error("ConnectionId undefined");

        this.connectionId = data.connection?.id! || data.pod?.connectionId!;
        this.connection = data.connection;

        if (data.pod)
            this.pod = new WhatsAppPod(data.pod);

        this.setTenant(this.connection, this.pod);
        this.mergeLabels(this.pod, this.connection);

        this.stringifiedLabels = this.stringfyLabels();

        if (data.pod?.niboWAHAContainer) {
            this.niboWAHAVersion = data.pod.niboWAHAContainer.image.split(':')[1];
        }
        
        this.wahaImage = data.wahaImage;
        this.niboWAHAImage = data.niboWAHAImage;
        this.niboWAHAChartVersion = data.niboWAHAChartVersion;
        this.wahaEnableTagEvents = data.wahaEnableTagEvents;
        this.wahaLogLevel = data.wahaLogLevel;
        this.vpaConfigWAHAMinAllowedMemory = data.vpaConfigWAHAMinAllowedMemory;
        this.vpaConfigWAHAMaxAllowedMemory = data.vpaConfigWAHAMaxAllowedMemory;
        this.volumeSize = data.volumeSize;
    }

    private mergeLabels(pod?: WhatsAppPod, connection?: WhatsAppConnection) {
        if (connection) {
            Object.keys(connection.labels).forEach(key => {
                this.labels[key.toLowerCase()] = connection.labels[key]?.toLowerCase();
            });
        }

        if (pod) {
            Object.keys(pod.labels).forEach(key => {
                this.labels[key.toLowerCase()] = pod.labels[key]?.toLowerCase().trim();
            });
        }
    }

    private setTenant(connection?: WhatsAppConnection, pod?: WhatsAppPod) {
        this.tenant = Tenant.All.find(t => t.id === connection?.tenant.id || t.id === pod?.tenant.id);
    }

    private stringfyLabels(): string {
        return Object.values(this.labels).join(';');
    }

}